interface BrandMarkProps {
  className?: string;
}

export const BrandMark = ({ className = "" }: BrandMarkProps) => (
  <span className={`inline-flex items-center gap-2.75 ${className}`}>
    <svg className="shrink-0 w-logo h-logo" viewBox="30 24 180 182" aria-hidden="true">
      <path d="M34 62 L76 38 L76 178 L34 202 Z" className="fill-brand-a" />
      <path d="M76 38 L162 102 L162 202 L76 138 Z" className="fill-brand-b" />
      <path d="M162 54 L206 28 L206 168 L162 202 Z" className="fill-brand-c" />
    </svg>
    <span className="font-brand text-brand-name text-ink">nablow</span>
  </span>
);
